/* Saját szállítási becslés – a beállításokat a [data-delivery-estimate] elemek data-* attribútumai adják. */
(function () {
  if (window.__dlvInit) return;
  window.__dlvInit = true;

  var MONTHS = ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'];
  var DAYS = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'];
  var TZ = 'Europe/Budapest';

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function key(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function addDays(d, n) { var r = new Date(d); r.setDate(r.getDate() + n); return r; }

  /* A budapesti „most”: dátum (helyi éjfélként) és óra */
  function budapestNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date())
      .forEach(function (p) { parts[p.type] = p.value; });
    return { date: new Date(+parts.year, +parts.month - 1, +parts.day), hour: +parts.hour };
  }

  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }

  function huHolidays(y) {
    var e = easter(y);
    return [y + '-01-01', y + '-03-15', y + '-05-01', y + '-08-20', y + '-10-23', y + '-11-01', y + '-12-25', y + '-12-26',
      key(addDays(e, -2)), key(addDays(e, 1)), key(addDays(e, 50))];
  }

  function list(str) {
    return (str || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function makeCalendar(el) {
    var off = {}, sat = {};
    list(el.dataset.holidays).forEach(function (d) { off[d] = true; });
    list(el.dataset.saturdays).forEach(function (d) { sat[d] = true; });
    if (el.dataset.huHolidays === 'true') {
      var y = new Date().getFullYear();
      [y, y + 1].forEach(function (yy) { huHolidays(yy).forEach(function (d) { off[d] = true; }); });
    }
    return function isWorkday(d) {
      var k = key(d), wd = d.getDay();
      if (off[k]) return false;
      if (wd === 0) return false;
      if (wd === 6) return !!sat[k];
      return true;
    };
  }

  function addWorkdays(d, n, isWorkday) {
    var r = new Date(d);
    while (n > 0) { r = addDays(r, 1); if (isWorkday(r)) n--; }
    return r;
  }

  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate() + '.'; }

  function fmtRange(a, b) {
    if (key(a) === key(b)) return fmt(a);
    if (a.getMonth() === b.getMonth()) return MONTHS[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate() + '.';
    return fmt(a) + ' – ' + fmt(b);
  }

  /* Érkezési dátum a nap nevével: „okt. 27. (kedd)”, tartománynál „okt. 27. (kedd) – 28. (szerda)” */
  function fmtDay(d) { return fmt(d) + ' (' + DAYS[d.getDay()] + ')'; }
  function fmtArrival(a, b) {
    if (key(a) === key(b)) return fmtDay(a);
    var tail = a.getMonth() === b.getMonth() ? b.getDate() + '. (' + DAYS[b.getDay()] + ')' : fmtDay(b);
    return fmtDay(a) + ' – ' + tail;
  }

  /* Expressz mező a Teeinblue űrlapon: a címében szerepel a kulcsszó */
  function expressField(keyword) {
    if (!keyword) return null;
    keyword = keyword.toLowerCase();
    var fields = document.querySelectorAll('#teeFormInputs .tee-field');
    for (var i = 0; i < fields.length; i++) {
      var h = fields[i].querySelector('.tee-field__heading');
      if (h && h.textContent.toLowerCase().indexOf(keyword) !== -1) return fields[i];
    }
    return null;
  }

  /* Kiválasztva, ha az első opció (Igen) aktív */
  function expressSelected(field) {
    if (!field) return false;
    var first = field.querySelector('.tee-radio:first-child');
    return !!first && (first.classList.contains('active') || !!(first.querySelector('input') || {}).checked);
  }

  function compute(el, express) {
    var d = el.dataset, isWorkday = makeCalendar(el), now = budapestNow();
    var cutoff = express ? +d.expressCutoff : +d.cutoff;
    var late = cutoff < 24 && now.hour >= cutoff && isWorkday(now.date);

    /* A feldolgozás kezdőnapja: ma, ha munkanap (sima rendelésnél határidő előtt), különben a következő munkanap.
       Expressznél a határidő után is aznap készül el, csak a kézbesítés tolódik. */
    var start = now.date;
    if (!isWorkday(start) || (late && !express)) start = addWorkdays(start, 1, isWorkday);

    var prepMin, prepMax, shipMin, shipMax;
    if (express) {
      prepMin = prepMax = +d.expressPrep;
      shipMin = shipMax = late ? +d.expressShipAfter : +d.expressShipBefore;
    } else {
      prepMin = +d.prepMin; prepMax = Math.max(+d.prepMax, prepMin);
      shipMin = +d.shipMin; shipMax = Math.max(+d.shipMax, shipMin);
    }

    var prepA, prepB, delA, delB;
    if (express) {
      /* Expressz: munkanapon 10 óráig aznap elkészül, és a következő munkanapon érkezik.
         10 után, illetve hétvégén/ünnepnapon a következő munkanapon készül el, és az azt követőn érkezik
         (pl. péntek 10 után, szombat, vasárnap → hétfő elkészül, kedd érkezik). */
      prepA = prepB = late ? addWorkdays(start, 1, isWorkday) : addWorkdays(start, prepMin, isWorkday);
      delA = delB = late ? addWorkdays(start, shipMin, isWorkday) : addWorkdays(prepA, shipMin, isWorkday);
    } else {
      /* Sima rendelés: a rendelés napja (ha munkanap) az elkészítés első napja, így 1–2 nap
         elkészítés = hétfői rendelésnél hétfő–kedd. A kézbesítés a rendelés napjától számolt
         (prepMin+shipMin)–(prepMax+shipMax) munkanap, a rendelés napját nem számolva:
         hétfő → szerda–péntek, vasárnap → kedd–csütörtök. Határidő után a következő munkanapot
         tekintjük a rendelés napjának. */
      var base = late ? start : now.date;
      prepA = addWorkdays(start, Math.max(prepMin - 1, 0), isWorkday);
      prepB = addWorkdays(start, Math.max(prepMax - 1, 0), isWorkday);
      delA = addWorkdays(base, prepMin + shipMin, isWorkday);
      delB = addWorkdays(base, prepMax + shipMax, isWorkday);
    }

    return {
      express: express,
      order: fmt(now.date),
      prep: fmtRange(prepA, prepB),
      delivery: fmtArrival(delA, delB),
      /* a lépéses dobozba nap neve nélkül (a nap neve csak a lenti mondatban van) */
      deliveryDate: fmtRange(delA, delB),
      summary: express
        ? '🔥 Ha most megrendeled, érkezés: <b>' + fmtDay(delA) + '</b>'
        : '🎁 ' + (key(delA) === key(delB)
          ? 'Ha most megrendeled, várható érkezés: <b>' + fmtDay(delA) + '</b>'
          : 'Ha most megrendeled, várhatóan <b>' + fmtDay(delA) + '</b> és <b>' + fmtDay(delB) + '</b> között érkezik.'),
      cutoff: cutoff < 24 && !late && isWorkday(now.date)
        ? (express
          ? 'Rendelj ma ' + cutoff + ':00-ig, és már a következő munkanapon nálad lehet.'
          : 'Rendelj ma ' + cutoff + ':00-ig, és már ma elkezdjük.')
        : ''
    };
  }

  function render() {
    document.querySelectorAll('[data-delivery-estimate]').forEach(function (el) {
      var field = expressField(el.dataset.expressKeyword);
      /* A kosárban a szerver jelzi, ha van expressz tétel */
      var r = compute(el, el.dataset.express === 'true' || expressSelected(field));
      /* Ajánló: ha van expressz mező, de nincs kiválasztva, mutassuk az expressz dátumát */
      r.offer = (field || el.dataset.expressOffer === 'true') && !r.express ? compute(el, true).delivery : '';
      r.compactLabel = r.express ? 'Érkezés:' : (el.dataset.compactText || '');
      el.querySelectorAll('[data-dlv]').forEach(function (t) {
        var v = r[t.getAttribute('data-dlv')] || '';
        /* csak változáskor írunk, különben a figyelő végtelen ciklusba kerülne */
        if (t.textContent !== v) t.textContent = v;
        if (t.dataset.dlv === 'cutoff' && t.hidden !== !v) t.hidden = !v;
      });
      /* saját, kiemelést tartalmazó szövegek (csak a fenti, általunk összerakott mondatok) */
      el.querySelectorAll('[data-dlv-html]').forEach(function (t) {
        var v = r[t.getAttribute('data-dlv-html')] || '';
        if (t.innerHTML !== v) t.innerHTML = v;
      });
      el.querySelectorAll('[data-dlv-offer]').forEach(function (t) { if (t.hidden !== !r.offer) t.hidden = !r.offer; });
      var yesInput = field && field.querySelector('.tee-radio:first-child input[id]');
      el.querySelectorAll('[data-dlv-add-express]').forEach(function (b) {
        var id = yesInput ? yesInput.id : '';
        if (b.htmlFor !== id) b.htmlFor = id;
      });
      el.querySelectorAll('[data-dlv-express]').forEach(function (t) { if (t.hidden !== !r.express) t.hidden = !r.express; });
      el.classList.toggle('dlv--express', r.express);
      if (el.hidden) el.hidden = false;
    });
  }

  function init() {
    render();
    /* A Teeinblue űrlap később jelenik meg és változik: expressz választásnál újraszámolunk */
    var timer, watched = false;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(render, 150);
    });
    /* Megvárjuk, amíg a Teeinblue űrlap megjelenik, utána csak azt figyeljük */
    function watchForm() {
      var form = document.getElementById('teeFormInputs');
      if (!form || watched) return;
      watched = true;
      finder.disconnect();
      observer.observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
      render();
    }
    var finder = new MutationObserver(watchForm);
    finder.observe(document.body, { subtree: true, childList: true });
    watchForm();
    setTimeout(function () { finder.disconnect(); }, 20000);
    /* A „Kérem az expresszt” egy natív <label>, amely az expressz mező „Igen” gombjára mutat:
       a kattintás így a böngészőtől érkezik, és a Teeinblue a kosárba is beteszi az opciót. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dlv-add-express]');
      if (!btn) return;
      var wrap = btn.closest('[data-delivery-estimate]');
      var field = expressField(wrap && wrap.dataset.expressKeyword);
      if (!field) return;
      if (!btn.htmlFor) {
        /* ha még nincs összekötve, a mező saját címkéjére kattintunk */
        var label = field.querySelector('.tee-radio:first-child .tee-radio-label');
        if (label) label.click();
      }
      setTimeout(function () { field.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 50);
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-dlv-add-express]')) {
        e.preventDefault();
        e.target.click();
      }
    });
    document.addEventListener('change', render);
    document.addEventListener('click', function () { setTimeout(render, 120); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
